import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";
import {
    saveGuestHotelRooms,
    nextStepAction,
    prevStepAction
} from "~/redux/actions/guests";
import RoomRow from "./RoomRow";
import produce from "immer";
import ValidationError from "~/Components/Forms/ValidationError";
import ToggleSwitch from '../../../Components/ToggleSwitch/ToggleSwitch';
import StepsNavigation from '../StepsNavigation';
import { QuestionMarkCircleIcon } from '../../../Components/Icons/Icons';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import TextTranslate from '../../../Components/TextTranslate/TextTranslate';
import { updateGuestFormUtil } from '../Utils/utils';

const HotelRooms = ({
    formData,
    activeGuest,
    activeStep,
    guests,
    isAdmin = false,
    ...props}) =>
{

    const [error, setError] = useState(null);

    const guest = !isAdmin ? guests[activeGuest] : guests;
    let form = !isAdmin ? formData[activeGuest][activeStep[activeGuest]] : formData;

    const defaultValues = {
        hotel_required: false,
        roomData: [],
        hotel_justification: '',
        hotel_comments: ''
    };

    form = {...defaultValues, ...form};

    const handleRequiredSwitch = (event) => {

        form = produce(form, (draft) => {
            draft.hotel_required = !draft.hotel_required;

            if (draft.hotel_required && draft.roomData.length === 0) {
                draft.roomData.push({});
            }
        });

        updateGuestFormUtil(form, isAdmin, props.onChange, props.dispatch);
    }

    const handleRoomChange = (roomKey, formValues) => {

        form = produce(form, (draft) => {
            draft.roomData[roomKey] = formValues;
        });

        updateGuestFormUtil(form, isAdmin, props.onChange, props.dispatch);
    }

    const handleRoomRemove = (roomKey) => {

        form = produce(form, (draft) => {
            draft.roomData.splice(roomKey, 1);

            if (draft.roomData.length === 0) {
                draft.hotel_required = false;
            }
        });

        updateGuestFormUtil(form, isAdmin, props.onChange, props.dispatch);
    }

    const handleRoomAdd = () => {
        form = produce(form, (draft) => {
            draft.roomData.push({});
        });

        updateGuestFormUtil(form, isAdmin, props.onChange, props.dispatch);
    }

    const handleTextInput = (event, name) => {
        form[name] = event.target.value;
        updateGuestFormUtil(form, isAdmin, props.onChange, props.dispatch);
    }

    const handlePrevious = () => {
        props.dispatch(prevStepAction());
    }

    const handleNext = () => {
        let promise = props.dispatch(saveGuestHotelRooms(guest.id, form));

        promise.then((data) => {

            setError(null);
            props.dispatch(nextStepAction());

        }).catch(error => {
            setError(error.data);
        });
    }

    const renderAccommodationTooltip = (props) => (
        <Tooltip id="accommodation-tooltip" {...props}>
            <TextTranslate name="form-hotel-accomodation-tooltip" fallback={`Should you be unsure of your hotel requirements please contact NEOMexperiences@csm.com or your NEOM representative for assistance.`}/>
        </Tooltip>
    );

    useEffect(() => {
        setError(props?.errors);
    }, [props?.errors])


    return (
        <>
            <div className="row">
                <div className="col-12">
                    {error?.message && (
                        <div className="alert alert-danger" role="alert">
                            {error.message}
                        </div>
                    )}

                    <h3>
                        <TextTranslate name="form-hotel-accomodation" fallback="Your accommodation"/>
                        <OverlayTrigger
                            placement="right"
                            delay={{show: 200, hide: 600 }}
                            overlay={renderAccommodationTooltip}
                        >
                            <div className="d-inline-block">
                                <QuestionMarkCircleIcon classes="svg-primary svg-16" />
                            </div>
                        </OverlayTrigger>
                    </h3>
                    <p><TextTranslate name="form-hotel-accomodation-note" fallback="Do you require hotel room(s) to be booked for you?"/></p>
                    <ToggleSwitch
                        label2={<TextTranslate name="hotel-room-require-yes" fallback="Yes, I require a hotel room(s)"/>}
                        onChange={e => {
                            handleRequiredSwitch(e)
                        }}
                        isChecked={form.hotel_required}
                        id="hotelRequired"
                    />
                </div>
            </div>
            {form.hotel_required && (
                <>
                    <hr/>

                    <div className="row mb-2">
                        <div className="col-12">
                            <h4><TextTranslate name="hotel-your-requirements" fallback="Your requirements"/></h4>
                            <small className="d-block">
                                <TextTranslate name="hotel-your-requirements-note" fallback="Please provide your arrival and departure dates, as well as the room types and quantity."/>
                            </small>
                        </div>
                    </div>

                    {form.roomData.map((room, key) => {
                        return (
                            <RoomRow key={key}
                                roomKey={key}
                                values={room}
                                errors={error?.errors}
                                onRemove={() => handleRoomRemove(key)}
                                onChange={(formValues) => handleRoomChange(key, formValues)}
                            />
                        )
                    })}

                    <div className="row mb-4">
                        <div className="col-12">
                            <a className="link text-primary text-caption" onClick={(e) => handleRoomAdd()}>
                                <TextTranslate name="hotel-room-add" fallback="Add another room"/>
                            </a>
                        </div>
                    </div>

                    {form.roomData.length > 1 && (
                        <div className="row">
                            <div className="col-12">
                                <div className="form-group">
                                    <label>Justification</label>
                                    <small className="d-block">Please provide a justification for the use of the additional rooms.</small>
                                    <textarea
                                        onChange={e => {handleTextInput(e, 'hotel_justification')}}
                                        className="form-control" rows="3" defaultValue={form.hotel_justification} />

                                    <ValidationError errors={error?.errors} name="hotel_justification" />
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="row">
                        <div className="col-12">
                            <div className="form-group">
                                <label className="mb-0"><TextTranslate name="word-comments" fallback="Comments"/></label>
                                <small className="d-block mb-1"><TextTranslate name="hotel-comments-note" fallback="Please specify any additional comments or requirements you may have." textOnly/></small>
                                <textarea
                                    onChange={e => {handleTextInput(e, 'hotel_comments')}}
                                    className="form-control" rows="3" defaultValue={form.hotel_comments} />

                                <ValidationError errors={error?.errors} name="hotel_comments" />
                            </div>
                        </div>
                    </div>
                </>
            )}

            {!isAdmin ?
                <StepsNavigation
                    fnPrevious={handlePrevious}
                    fnNext={handleNext}
                /> : null
            }
        </>
    )
}

const mapStateToProps = (state, componentProps) => ({
    guests: state.guests?.list || componentProps.guest,
    activeGuest: state.guests?.activeGuest,
    activeStep: state.guests?.activeStep,
    formData: state.guests?.formData || componentProps.formData
});

export default connect(mapStateToProps)(HotelRooms);
